import {OverwolfXPTransaction} from "@devour/client";
import {isDesktop} from "react-device-detect";
import {useSelector} from "react-redux";
import {IStore} from "@/redux/defaultStore";
import GoVipOWTimeBasedRewardCard from "@/components/goVip/GoVipOWTimeBasedRewardCard";
import GameQuestSuggestions from "@/components/games/GameQuestSuggestions";


interface Props {
    rewards: Array<OverwolfXPTransaction>;
    gameId?: string;
    onLoginClick?: () => void;
}

export default function OverwolfGoVipTimeRewards(props: Props) {
    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);
    const isAuthenticated = !!fullToken;
    const overwolfAppUrl = "https://www.overwolf.com/app/Devour-DevourPlay";

    const handleLoginClick = () => {
        if (props.onLoginClick) {
            props.onLoginClick();
        }
    };

    const handleDownloadClick = () => {
        window.open(overwolfAppUrl, "_blank", "noopener,noreferrer");
    };

    if (!props.rewards?.length) {
        return (
            <div className="overwolf-govip_rewards_time_empty">
                <img
                    src={`${import.meta.env.VITE_CDN_URL}/images/govip-ow-time-rewards-modal-empty.webp`}
                    alt="Overwolf Time Rewards Empty"
                />
                <h5>Need more battle time?</h5>
                <span>
                    No XP earned yet. Deploy into battle to start earning rewards. {isDesktop && <br/>}Deploy for an hour of combat to earn your first XP!
                </span>

                {/* Show link account prompt for unauthenticated users */}
                {!isAuthenticated &&
                    <div className="overwolf-govip_rewards_time_empty__unauth" style={{
                        marginTop: "2rem",
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}>
                        <h5 style={{
                            fontSize: "1.2rem",
                            marginBottom: "1rem",
                            fontWeight: "600",
                            textAlign: "center",
                        }}>Grab DevourPlay and dive in.</h5>
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "0.75rem",
                            width: "100%",
                            maxWidth: "280px",
                        }}>
                            <button
                                className="overwolf-govip_rewards_time_empty__login-btn"
                                onClick={handleLoginClick}
                                style={{
                                    padding: "0.875rem 2rem",
                                    background: "linear-gradient(135deg, #F1161D 0%, #7859E6 100%)",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "50px",
                                    fontWeight: "600",
                                    cursor: "pointer",
                                    fontSize: "1rem",
                                    width: "100%",
                                    whiteSpace: "nowrap",
                                    transition: "transform 0.2s",
                                }}
                            >
                                Login or SignUp
                            </button>
                            <button
                                className="overwolf-govip_rewards_time_empty__download-btn"
                                onClick={handleDownloadClick}
                                style={{
                                    padding: "0.875rem 2rem",
                                    background: "transparent",
                                    color: "white",
                                    border: "2px solid white",
                                    borderRadius: "50px",
                                    fontWeight: "600",
                                    cursor: "pointer",
                                    fontSize: "1rem",
                                    width: "100%",
                                    whiteSpace: "nowrap",
                                    transition: "all 0.2s",
                                }}
                            >
                                Download DevourPlay
                            </button>
                        </div>
                    </div>
                }
            </div>
        );
    }

    return (
        <div className="overwolf-govip_rewards_time_list">
            {props.rewards.map((reward: OverwolfXPTransaction) =>
                <GoVipOWTimeBasedRewardCard
                    reward={reward}
                    key={reward.id}/>)}
        </div>
    );
}